import { MeControlNamespace } from '@mecontrol/common';

export const w = window;

// Setup shared global objects;
export const ME: MeControlNamespace = (w.MeControl = w.MeControl || {}) as any;
